module.exports = __webpack_public_path__ + "assets/images/roster-management.e69cbd02c2e3e3c02ce5aee5c554a3c8.svg";